import request from '@/utils/request'

  export function store(data) {
    return request({
      url: '/assent/advance_salary',
      method: 'post',
      data
    })
  }
  export function index(id) {
    return request({
      url: `/assent/advance-salary/${id}`,
      method: 'get',
      
    })
  }

